import moment from 'moment';

export default {
    initStore(state) {
        const cartInfo = window.localStorage.getItem('cartInfo');

        if (cartInfo !== null && cartInfo !== undefined) {
            const expirationDate = moment().subtract(2, 'days');
            if (moment(cartInfo.datetime) < expirationDate) {
                window.localStorage.removeItem('cartInfo');
                return;
            }
            this.replaceState(Object.assign(state, JSON.parse(window.localStorage.getItem('cartInfo'))));
        }
    },
    clearStorage(state) {
        window.localStorage.removeItem('cartInfo');
        state.cartInfo = {
            datetime: null,
            items: []
        };
    },
    setProduct(state, payload) {
        state.productDetail = payload;
    },
    addToCart(state, payload) {
        var existingObj = state.cartInfo.items.find(obj => {
            return obj.id === payload.id && obj.name === payload.name && obj.ralColor === payload.ralColor && obj.implementation === payload.implementation && obj.option === payload.option;
        });
        if (existingObj !== undefined) {
            existingObj.qty++;
        } else {
            state.cartInfo.items.push(payload);
        }
        state.cartInfo.datetime = moment().format();
    },
    increaseCartItemQty(state, item) {
        var existingObj = state.cartInfo.items.find(obj => {
            return obj.id === item.id && obj.name === item.name && obj.ralColor === item.ralColor && obj.implementation === item.implementation && obj.option === item.option;
        });

        if (existingObj === undefined) {
            return;
        }

        existingObj.qty++;
    },
    decreaseCartItemQty(state, item) {
        var existingObjIndex = state.cartInfo.items.findIndex(obj => {
            return obj.id === item.id && obj.name === item.name && obj.ralColor === item.ralColor && obj.implementation === item.implementation && obj.option === item.option;
        });

        if (existingObjIndex === -1) {
            return;
        }

        state.cartInfo.items[existingObjIndex].qty--;

        if (state.cartInfo.items[existingObjIndex].qty <= 1) {
            state.cartInfo.items[existingObjIndex].qty = 1;
        }
    },
    removeItem(state, item) {
        var existingObjIndex = state.cartInfo.items.findIndex(obj => {
            return obj.id === item.id && obj.name === item.name && obj.ralColor === item.ralColor && obj.implementation === item.implementation && obj.option === item.option;
        });

        if (existingObjIndex === -1) {
            return;
        }

        state.cartInfo.items.splice(existingObjIndex, 1);
    },
    setLanguage(state, payload) {
        if (state.i18n.translations[payload.locale] === undefined) {
            state.i18n.translations[payload.locale] = {};
        }

        if (payload.translations === '') {
            state.i18n.translations[payload.locale] = {};
        } else {
            state.i18n.translations[payload.locale] = payload.translations;
        }

        state.baseLocaleLoaded = true;
    },
    setTranslation(state, payload) {
        if (state.i18n.translations[payload.locale] === undefined) {
            state.i18n.translations[payload.locale] = {};
        }
        state.i18n.translations[payload.locale][payload.key] = payload.value;
    }
};
